import { handleLambdaChartPoints, handleLiaoChartPoints } from './chartPoints';
import { ChartData } from '../../@types/data/types';
import {
  NonNullableLiaoAnalysisResults,
  NonNullableWaterOilInputSampleCurves,
  NonNullableLambdaAnalysisResults,
  NonNullableLiaoSampleResults,
  NonNullableLambdaSampleResults
} from '../../@types/samples/types';

export const handleLiaoChartData = (
  liaoAnalysisResults: NonNullableLiaoAnalysisResults,
  liaoSampleResults: NonNullableLiaoSampleResults,
  sampleCurves: NonNullableWaterOilInputSampleCurves,
  setNewChartData: React.Dispatch<React.SetStateAction<ChartData>>
) => {
  const { PcD, x, y, SwD } = liaoAnalysisResults;

  const { best_a, best_b, lambda_variable } = liaoSampleResults;

  const pc_x_sw = sampleCurves.pc.map((field, index) => ({
    x: Number(sampleCurves.sw[index]),
    y: Number(field)
  }));

  const pceMatch = liaoAnalysisResults.PceMatch ?? liaoAnalysisResults.Pres;

  const PceMatch_x_CorrectedSw = pceMatch.map((field, index) => ({
    x: Number(liaoAnalysisResults.CorrectedSw[index]),
    y: Number(field)
  }));

  const line = x.map((value, index) => ({
    x: Number(value),
    y: Number(y[index])
  }));

  const PcD_x_SwD = PcD.map((field, index) => ({
    x: Number(SwD[index]),
    y: Number(field)
  }));

  handleLiaoChartPoints(
    liaoAnalysisResults,
    setNewChartData,
    sampleCurves,
    liaoSampleResults
  );
  setNewChartData(prevState => ({
    ...prevState,
    new_pcxsw: [],
    pcxsw: pc_x_sw,
    correctedPcxsw: PceMatch_x_CorrectedSw,
    line,
    pcdxswd: PcD_x_SwD,
    variables: {
      a: best_a,
      b: best_b,
      lambda: lambda_variable,
      PceD: Math.min(...PcD.filter((value): value is number => value !== null))
    }
  }));
};

export const handleLambdaChartData = (
  lambdaAnalysisResults: NonNullableLambdaAnalysisResults,
  lambda: NonNullableLambdaSampleResults,
  sampleCurves: NonNullableWaterOilInputSampleCurves,
  setNewChartData: React.Dispatch<React.SetStateAction<ChartData>>
) => {
  const pc_x_sw = sampleCurves.pc.map((field, index) => ({
    x: Number(sampleCurves.sw[index]),
    y: Number(field)
  }));

  const correctedPcXCorrectedSw = lambdaAnalysisResults.CorrectedPc.map((field, index) => ({
    x: Number(lambdaAnalysisResults.CorrectedSw[index]),
    y: Number(field)
  }));

  handleLambdaChartPoints(lambdaAnalysisResults, setNewChartData, sampleCurves);
  setNewChartData(prevState => ({
    ...prevState,
    new_pcxsw: [],
    pcxsw: pc_x_sw,
    correctedPcxsw: correctedPcXCorrectedSw,
  }));
};
